import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Mail, Instagram, Facebook, Music2 } from "lucide-react";
import { SOCIALS, ASSETS } from "@/lib/data";
import { Reveal } from "./Reveal";

const ICONS = {
  whatsapp: MessageCircle,
  email: Mail,
  tiktok: Music2,
  instagram: Instagram,
  facebook: Facebook,
};

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 bg-void" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-8">
        <Reveal className="flex flex-col items-center text-center">
          <img src={ASSETS.heroLogo} alt="Pahlawan Championship" className="h-auto w-52 object-contain" />

          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.key];
              return (
                <a
                  key={s.key}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  className="group flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-slate-300 transition-all duration-300 hover:border-neon-pink hover:text-white hover:shadow-[0_0_25px_-4px_rgba(255,0,216,0.7)]"
                  data-testid={`social-${s.key}`}
                  aria-label={s.label}
                >
                  <Icon className="h-4 w-4 transition-transform group-hover:scale-110" />
                </a>
              );
            })}
          </div>

          <a
            href="https://pahlawanchampionship.com"
            target="_blank"
            rel="noreferrer"
            className="mt-4 font-mono-cap text-[11px] text-neon-cyan hover:underline"
            data-testid="footer-website"
          >
            pahlawanchampionship.com
          </a>
          <Link
            to="/refund-policy"
            className="mt-2 font-mono-cap text-[10px] text-slate-500 transition-colors hover:text-neon-cyan"
            data-testid="footer-refund-link"
          >
            Refund & Return Policy
          </Link>
        </Reveal>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-white/10 pt-5 sm:flex-row">
          <p className="font-mono-cap text-[10px] text-slate-500">© 2026 Pahlawan Championship</p>
          <p className="font-mono-cap text-[10px] text-slate-500">Bringing Muay Thai To Life · Since 2009</p>
        </div>
      </div>
    </footer>
  );
};
